module.exports = __webpack_public_path__ + "img/IMG_5901.2197d31c.jpg";